import React from 'react';
import Icon from '../Icon';

function AlertItem({ icon = 'alert-triangle', iconBg, iconColor, title, desc, time, badge, onClick }) {
  return (
    <div className="alert-item" onClick={onClick}>
      <div className="alert-icon" style={{ background: iconBg || 'rgba(139,92,246,0.15)', color: iconColor || '#a78bfa' }}>
        <Icon name={icon} size={16} />
      </div>
      <div className="alert-body">
        <div className="alert-title">
          {title}
          {badge}
        </div>
        {desc && <div className="alert-desc">{desc}</div>}
      </div>
      {time && <span className="alert-time">{time}</span>}
    </div>
  );
}

export default AlertItem;
